import React, { Component } from 'react';
import $ from 'jquery';
import {
  isMobile, isIOS
} from "react-device-detect";
import ModelSide from './ModelSide';
import Modeldetailpopup from './popup/Modeldetailpopup';
import {number_format , getUrlVars} from './helper/format';

import './helper/IE.js';
import 'es6-promise/auto'

class Main extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      models: [],
      allmodels: [],
      select_model: null,
      select_model_idx: 0,
      selectedTab: '',
      order: 0,
      OptionType: 1,
      OptionTypeArray: ["", "신규가입","기기변경","번호이동"],
      tableMobileHeight: {},
      isApp : (window.webkit !== undefined && window.webkit.messageHandlers !== undefined && window.webkit.messageHandlers.moreAction !== undefined) ? true : false
    }
    this.searchTextObj = null;
    this.orderbyManu = {
        "삼성" : 1,
        "애플" : 2,
        "LG"   : 3,
        "기타" : 4
    };
    this.loginKey = sessionStorage.getItem('loginKey');
    if( !this.loginKey || this.loginKey == "" )
    {
       this.loginKey = localStorage.getItem('loginKey');
    }

    let params = getUrlVars();
    if( this.loginKey == "" )
    {
      //alert('다시 로그인 부탁드립니다.');
      window.location.href = '/Login?guide=' + params.guide;
      return false;
    }

    if( !this.loginKey )
    {
        window.location.href = '/Login?guide=' + params.guide;
        return false;
    }
    this.logoPath = "";
    this.logoPath = sessionStorage.getItem('logo');
    if( !this.logoPath || this.logoPath == "" )
    {
      this.logoPath = localStorage.getItem('logo');
    }
  }
  on_model_select(idx)
  {
    var select_model = null;
    for ( var i = 0; i < this.state.models.length ; i++ )
    {
      var model = this.state.models[i];
      if( model.idx == idx ) {
        select_model = model;
      }
    }
    if( isMobile ) {
      this._modeldetailPopup.Open();
    } else {
      if( this.state.select_model_idx == idx )
      {
          this.moveDetail();
          return true;
      }
    }
    this.setState({
      select_model : select_model,
      select_model_idx : idx,
    });
  }
  on_filter(filter_value)
  {
    var filterd_item = [];
    if( filter_value == '' )
    {
      filterd_item = this.state.allmodels;
    }
    else
    {
        var fItem = [];
        for(var i = 0 ; i < this.state.allmodels.length ; i++ )
        {
          var item = this.state.allmodels[i];
          if( item.manufacturer == filter_value )
          {
            fItem.push(item);
          }
        }
        filterd_item = fItem;
    }
    this.setState({
      selectedTab : filter_value,
      models : filterd_item
    });
  }
  on_order(type) {
    var ordered_itme = [];
    if ( type == 1) {
        this.state.models.sort(function(a, b){
            //return a.manuOrder < b.manuOrder ? -1 : a.manuOrder > b.manuOrder ? 1 : 0;
            return a.idx > b.idx ? -1 : a.idx < b.idx ? 1 : 0;
        });
    } else if ( type == 2 ) {
      this.state.models.sort(function(a, b){
        let d1 = Date.parse(a.released_date), d2 = Date.parse(b.released_date);
        return d1 > d2 ? -1 : 0;
      });
    } else if( type == 3 ) {
      this.state.models.sort(function(a, b){
        return a.release_price < b.release_price ? -1 : a.release_price > b.release_price ? 1 : 0;
      });
    }
    ////select_model_idx: select_model_idx,
    //select_model: select_model,

    this.setState(
      {
        select_model_idx: this.state.models[0].idx,
        select_model: this.state.models[0],
        order:type
      }
    );
  }
  componentDidMount() {
    const self = this;
    let params = getUrlVars();
    if( params.idx )
    {
        this.setState({
            OptionType: params.idx
        });
    }
    this.requetModelData();
    /*
    if( isIOS && window.webkit.messageHandlers && window.webkit.messageHandlers.moreAction ) {
      this.setState({
        isApp : true
      });
    }
    */
  }

  mobileView() {
    let topContainer = $('#topHeader');
    let SearchContainer = $('#SearchContainer');
    let tabContainer = $('#tabContainer');

    let top = document.getElementById('topHeader').clientHeight;
    let search = SearchContainer.get(0).clientHeight;
    let tab = tabContainer.get(0).clientHeight;
    let removeHeight = top;
    let windowHeight = $(window).height();

    this.setState({
      tableMobileHeight : {
        height: (windowHeight - removeHeight) + 'px'
      }
    });
  }

  requetModelData() {
    var self = this;
    $.get('https://api.tfamily.co.kr/api/mobile/devices',{},function(data){
      var models = JSON.parse(data);
      var select_model_idx = 0;
      var select_model = null;
      if( models.data.length > 0 )
      {
        select_model_idx = models.data[0].idx;
        select_model = models.data[0];
        for(let i = 0 ; i < models.data.length; i++) {
            models.data[i].manuOrder = self.orderbyManu[models.data[i].manufacturer];
        }
      }
      self.setState(
        {
          //select_model_idx: select_model_idx,
          //select_model: select_model,
          models: models.data,
          allmodels: models.data
        }
      ,self.completeData);
    });
  }
  completeData() {
    if( isMobile ) {
      this.mobileView();
    }
    this.on_order(2);
  }
  handleChange()
  {
    var txt = this.searchTextObj.value;
    var selectedTab = this.state.selectedTab;

    var targetList = this.state.allmodels;
    var searchedList = [];
    if( txt == '' )
    {
      if( selectedTab == '' )
      {
        searchedList = this.state.allmodels;
      } else {
        for(var i=0;i<this.state.allmodels.length;i++)
        {
          if(this.state.allmodels[i].manufacturer == this.state.selectedTab)
          {
            searchedList.push(this.state.allmodels[i]);
          }
        }
      }
    } else {
      for(var i=0;i<this.state.allmodels.length;i++)
      {
        var manu = false;
        if( selectedTab == '' ) {
          manu = true;
        }
        if((manu || this.state.allmodels[i].manufacturer == this.state.selectedTab) && this.state.allmodels[i].name.toLowerCase().indexOf(txt.toLowerCase()) != -1)
        {
          searchedList.push(this.state.allmodels[i]);
        }
      }
    }

    this.setState({
      models : searchedList
    });

  }
  moveDetail()
  {
    window.location.href = '/Detail/' + this.state.select_model_idx + '?name=' + encodeURI(this.state.select_model.name) + '&OptionType=' + this.state.OptionType + '&color=' + this._modelSide.getName();
  }


  on_order_change(e) {
    if(e.target.value != "") {
      this.on_order(e.target.value);
    }
  }

  onModelSelect()
  {
    window.location.href = '/Detail/' + this.state.select_model_idx + '?name=' + encodeURI(this.state.select_model.name) + '&OptionType=' + this.state.OptionType + '&color=' + this._modeldetailPopup.getName();
  }

  logout()
  {
    localStorage.setItem('loginKey', "");
    sessionStorage.setItem('loginKey',"");
    window.location.href = '/Login';
  }

  changePassword()
  {
    window.location.href = '/ChangePasswd';
  }

  moveTfamily()
  {
    window.webkit.messageHandlers.moreAction.postMessage('https://tfamily.co.kr?guide=true');
  }

  render()
  {
    var self = this;
    let height = $(document).height();
    let footFixed = true;
    //console.log(height);
    if( height < 900)
    {
      footFixed = false;
    }
    return(
        (self.loginKey) ?
        <div className={(isMobile) ? null : 'centralize-wrapper bgGray'}>
        <div className={(isMobile) ? null : 'centralize-inner'}>
          <div className="container borderCD bgWhite">
          <div className="row text-right logout">
			<div style={{'position':'absolute', fontSize:'14px'}}>
				<a href="/board/notice">공지사항</a>&nbsp;&nbsp;<a href="/board/review">이벤트</a>
			</div>
            {this.loginKey === "dHYraFJOMFZzS24vblNvUXdKMUtZL2lleUtUOUlMSXZaZmZhVjRPSFIrUT0=" ? "" : <a href="#logout" className="requirefield" onClick={self.changePassword.bind(this)}>비밀번호변경</a>}
            &nbsp;&nbsp;&nbsp;
            <a href="#logout" className="requirefield" onClick={self.logout.bind(this)}>로그아웃</a>
          </div>
            <div className="row">
              <div className="col-md-8 col-xs-12 col-sm-12">
                <div id="topHeader" className="row">
                    <div className="col-xs-12">
                      <h1>
                      {(self.logoPath && self.logoPath !=="") ?
                        <img src={'https://api.tfamily.co.kr/' + self.logoPath} className="text-right logoMax"/>
                      :null}
                        &nbsp;<b>휴대폰 선택</b>
                      </h1>
                    </div>
                  <div id="SearchContainer" className="col-xs-12 searchbox pt10">
                      <input type="search" onChange={()=>{self.handleChange()}} ref={(ref)=>{this.searchTextObj = ref}} className="form-control searchbar non-radius" placeholder="검색할 휴대폰을 입력해주세요" />
                      <div className="search_icon"><img src={'/img/search.png'} /></div>
                    </div>
                  </div>
                  <div id="tabContainer" className="row mt20 mb20">
                    <ul className="nav nav-pills manu-nav">
                      <li role="presentation" className={ self.state.selectedTab == '' ? 'active' : ''}><a onClick={()=>self.on_filter('')} href="#">전체</a></li>
                      { (!this.state.isApp) ?  <li role="presentation" className={ self.state.selectedTab == '삼성' ? 'active' : ''}><a onClick={()=>self.on_filter('삼성')} href="#samsung">삼성</a></li> : null }
                      { (!this.state.isApp) ? <li role="presentation" className={ self.state.selectedTab == 'LG' ? 'active' : ''}><a onClick={()=>self.on_filter('LG')} href="#lg">LG</a></li> : null }
                      <li role="presentation" className={ self.state.selectedTab == '애플' ? 'active' : ''}><a onClick={()=>self.on_filter('애플')} href="#apple">애플</a></li>
                      { (!this.state.isApp) ? <li role="presentation" className={ self.state.selectedTab == '기타' ? 'active' : ''}><a onClick={()=>self.on_filter('기타')} href="#others">기타</a></li> : null }
                    </ul>
                    {(isMobile) ?
                      <div className={'txtRight pt40'}>
                      <select onChange={self.on_order_change.bind(this)}>
                        <option value="">정렬없음</option>
                        <option value="1">인기순</option>
                        <option value="2">신제품순</option>
                        <option value="3">할부원금순</option>
                      </select>
                      </div> :
                      <div className={'orderRight txtRight'}>
                        <a href="#order" className={(this.state.order==1) ? 'active' : '' } onClick={()=>self.on_order(1)}>인기순</a>
                        &nbsp;&nbsp;&nbsp;<a href="#order" className={(this.state.order==2) ? 'active' : '' } onClick={()=>self.on_order(2)}>신제품순</a>
                        &nbsp;&nbsp;&nbsp;<a href="#order" className={(this.state.order==3) ? 'active' : '' } onClick={()=>self.on_order(3)}>할부원금순</a>
                      </div>
                    }
                  </div>

                <div className="row mt40 hide">
                  <table className="table modelGuide mb0">
                    <thead>
                      <tr>
                        <th className="col-md-3 text-center">제품명</th>
                        {(!isMobile) ? <th className="col-md-3 text-center">모델명</th> : null }
                        {(!isMobile) ? <th className="col-md-2 text-center">출고가</th> : null }
                        {(!isMobile) ? <th className="col-md-2 text-center">공통지원금</th> : null }
                        <th className="col-md-2 text-center">할부원금</th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div className="row scroll600" style={this.state.tableMobileHeight}>
                  <table className="modeltable modelGuide table">
                  <thead>
                    <tr>
                      <th className="col-md-3 text-center">제품명</th>
                      {(!isMobile) ? <th className="col-md-3 text-center">모델명</th> : null }
                      {(!isMobile) ? <th className="col-md-2 text-center">출고가</th> : null }
                      {(!isMobile) ? <th className="col-md-2 text-center">공통지원금</th> : null }
                      <th className="col-md-2 text-center">할부원금</th>
                    </tr>
                  </thead>
                    <tbody>
                      {this.state.models.map(model=>{
                        if ( model.manufacturer !== '애플' && this.state.isApp ) {
                          return null;
                        }
                        return(
                          <tr key={'model'+model.idx} className={ (this.state.select_model_idx == model.idx && !isMobile) ? 'select' : '' }
                            onClick={() => self.on_model_select(model.idx)}
                            >
                            <td className="col-md-3 model-name"><b>{model.name}</b>
                              {(isMobile) ? <div><small>{model.model}</small></div> : null}
                              {(model.is_5g === 1) ? <React.Fragment>&nbsp;&nbsp;<span className="label label-info" style={{"backgroundColor":"#D22D11"}}>5G</span></React.Fragment> :null }
                            </td>
                            {(!isMobile) ? <td className="col-md-3">{model.sold_out == 1 ? <>
		<span className="label label-warning">
		품절
		</span>
		</> : <></>} {model.model}</td> : null }
                            {(!isMobile) ? <td className="col-md-2 text-center">{number_format(model.release_price)}</td> : null }
                            {(!isMobile) ? <td className="col-md-2 text-center">{number_format(model.subsidy)}</td> : null}
                            <td className="col-md-2 text-center">
                              {number_format(model.release_price-model.subsidy)}
                            </td>
                          </tr>)
                      })}
                    </tbody>
                  </table>

                  <div>
                   {(isIOS && this.state.isApp ) ? <button className="btn btn-bar btn-lg" onClick={self.moveTfamily.bind(this)}>타 제조사 제품보기</button> : ""}
                  </div>

                </div>
              </div>
              <div className="col-md-4 col-xs-12">
                {(isMobile) ? null :
                  <ModelSide
                    ref={(ref)=>{this._modelSide=ref;}}
                    select_model_idx={this.state.select_model_idx}
                    select_model={this.state.select_model}/>
                 }
              </div>
            </div>
            {(!isMobile) ?
              <div className="row pt40">
                  <a className="btn btn-default btn-lg btn-select" href="/Option">
                      뒤로 - {self.state.OptionTypeArray[self.state.OptionType]}
                  </a>
                  &nbsp;&nbsp;&nbsp;
                  {(self.state.select_model != null) ?
                    <a className="btn btn-default btn-lg btn-select" style={{float:'right'}} onClick={()=>{self.moveDetail()}}>
                    {self.state.select_model.name} - 선택
                    </a>
                    : null
                   }

                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
               : null
             }


             {(isMobile) ?
                <div></div> :
            null}

            <br/>

          </div>
          {(true) ?   <div className={ (true) ? 'footerClass2' : 'footerClass' }>
              <div className="container">
                <div className="col-xs-12">
                  <div className="row pt15 pb15">

                    <div className="col-md-4">

                    </div>
                    <div className="col-xs-12 col-md-4 text-left">
                      <ul className="nonelist col-small">
                        <li>가입 및 상담 대표 번호 TEL: 1599-5168</li>
                        <li>아이디 및 비밀번호 분실시 대표 번호로 문의 바랍니다.</li>
                        <li>카카오 플러스 친구 "T패밀리몰" 검색</li>
                        <li><a href="/agree/our.html">서비스 이용약관</a>,
                        <a href="/agree/private.html">개인정보 취급방침</a></li>
                        <li>개인정보 보호책임자 : 팀장 이지범</li>
                        <li>통신판매업 : 제2020-대구수성구-0289호</li>
                      </ul>
                    </div>

                    <div className="col-xs-12 col-md-4 col-small">
                      <ul className="nonelist">
                        <li>근무시간 : 평일 09시 ~ 20시</li>
                        <li>토요일 및 공휴일 11시 ~ 20시(일요일 휴무)</li>
                        <li>E-MAIL: 216-2265@naver.com</li>
                        <li>바른정보통신(사업자번호 : 662-88-00280) 대표자 : 최형종</li>
                        <li>대구시 수성구 달구벌대로 2349 수협G타워 901호</li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </div> : null }



        </div>
        <Modeldetailpopup
          onModelSelect={this.onModelSelect.bind(this)}
          select_model_idx={this.state.select_model_idx}
          select_model={this.state.select_model}
          ref={(ref)=>{this._modeldetailPopup = ref;}}/>
      </div>
        : ''
    );
  }
}

export default Main;

